<template>
  <div class="animated fadeIn">
    <b-card no-body class="card-default mt-3 vh-85">
      <div slot="header">
        <strong>{{materia}}</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action" @click="returnParent(actualDir)">
            <i class="icon-action-undo"></i> Regresar
          </b-link>
        </div>
      </div>
      <b-card-body style="overflow-y: auto;">
        <NavContent :view-dirs="true" :view-list="true" v-on:styleList="onSelectStyleList($event)">
          <template slot="tituloCabecera">{{materia}}</template>
        </NavContent>
        <filtro-directorios
          :show-filter="showFilter"
          v-on:filter="targetFilter"
          v-on:reset="resetFiltro"
        />

        <slot v-if="typeViewList == 'block'">
          <DirectoriosContent
            :data-dir="materiaObj"
            :records="recordsDir"
            @change-dir="changeDataDir($event)"
            @return-dir="returnDir($event)"
          />
        </slot>
        <slot v-else-if="typeViewList == 'list'">
          <TableContentDirectorios
            :buttons="buttonsBlock"
            :table-data="recordsDir"
            :fields="tableFields"
            :per-page="dataPagination.limit"
            :show-pagination="false"
            @return-dir="returnDir($event)"
            @change-dir="changeDataDir($event)"
          />
        </slot>
        <!--<nav>
          <b-pagination
            :total-rows="dataPagination.totalPages"
            :per-page="dataPagination.limit"
            v-model="dataPagination.page"
            prev-text="Anterior"
            next-text="Siguiente"
            hide-goto-end-buttons
            class="paginador-cme"
          />
        </nav>-->
      </b-card-body>
    </b-card>
    <slot>
      <b-button @click="goNuevoMaterial" variant="primary" class="btn btn-fixed font-1xl">
        <font-awesome-icon icon="plus" />&nbsp; Nuevo Material
      </b-button>
    </slot>
  </div>
</template>
<style lang="scss" scoped>
.card-header-action:hover {
  color: #e3f9ff;
}
.d-block {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<script>
function strip_html_tags(str) {
  if (str === null || str === "") {
    return false;
  } else {
    str = str.toString();
    str = str.replace(/&nbsp;/gi, "");
    str = str.replace(/<[^>]*>/gi, "");
    return str;
  }
}

import MaterialService from "@/services/material.service";
import NavContent from "@/components/NavContent";
import DirectoriosContent from "@/components/DirectoriosContent";
import TableContentDirectorios from "@/components/TableContentDirectorios";
import DirectorioService from "@/services/directorio.service";
import FiltroDirectorios from "@/components/FiltroDirectorios";
import UserService from "../services/user.service";

export default {
  name: "Cursos",
  components: {
    NavContent,
    TableContentDirectorios,
    DirectoriosContent,
    FiltroDirectorios
  },
  data() {
    return {
      materia: "",
      materiaObj: null,
      actualDir: null,
      //materias:this.$store.getters['directorio/getListCursos'],
      user: null,
      recordsDir: new Array(),
      //directorios:new Array,
      materiales: new Array(),
      arrayBlockElements: new Array(),
      arrayTableElements: [],
      buttonsBlock: [
        {
          icon: "eye",
          popover: "Abrir",
          id: "btn-show"
        }
        /*{
          icon: "pen",
          id: "btn-edit"
        }*/
      ],
      paramsDirs: {
        paginate: true,
        filtro: {
          author: null,
          father: null,
          estatus: "ACTIVO"
        },
        section: 'Cursos'
      },
      paramsMtls: {
        paginate: true,
        filtro: {
          author: null,
          father: null,
          estatus: "ACTIVO"
        },
        section: 'Cursos'
      },
      dataPaginationDirs: { page: 1, totalPages: 2 },
      dataPaginationMtls: { page: 1, totalPages: 2 },
      typeViewList: "block",
      tableFields: [
        /*{ key: null, label: " ", sortable: false, class: "text-center" },
        { key: "name", label: "Título", sortable: true, class: "text-center" },
        {
          key: "fechaUltimaActualizacion",
          label: "Última Acualización",
          sortable: true,
          class: "text-center"
        }*/
        { key: "type", label:"", class:'text-center size-icon-tb' },
        { key: "name", label: "Título", tdClass:'nameWidth', sortable: true, class:'text-center' },
        { key: "fechaUltimaActualizacion", label: "Fecha Eliminado", sortable: true, class:'text-center', thStyle: {width: ''} },
        { key: "actions" ,label:"", class:'text-center', thStyle: {width: '10%'}}
      ],
      dataPagination: {
        page: 1,
        limit: 0,
        totalDocs: 0,
        totalPages: 0
      },
      flagSearch: false,
      showAll: false,
      showFilter: false,
      wordSearch: ""
    };
  },
  watch: {
    $route(to, from) {
      this.materia = this.$route.params.materia;
      var objCursoPromise = this.$store.dispatch(
        "directorio/getInfoCurso",
        this.materia
      );
      objCursoPromise
        .then(obj => {
          if (obj._id) {
            this.materiaObj = obj;
            this.actualDir = obj;
            this.paramsDirs.filtro.father = this.materiaObj._id;
            this.paramsMtls.filtro.father = this.materiaObj._id;
            this.getRecordsDir(1);
            return 0;
          } else
            return DirectorioService.list(1, {
              filtro: { name: this.materia }
            });
        })
        .then(response => {
          if (response) {
            this.materiaObj = response[0];
            this.actualDir = response[0];
            this.getRecordsDir(1);
          }
        });
    }
  },
  methods: {
    onSelectStyleList(e) {
      console.log(e);
      switch (e) {
        case "newDir":
          this.onNewDir();
          break;
        case "block":
          this.typeViewList = e;
          break;
        case "list":
          this.typeViewList = e;
          break;
        case "filter":
          this.showFilter = !this.showFilter;
          break;
      }
      //this.typeViewList = e;
    },
    goNuevoMaterial() {
      let materialTree = JSON.parse(JSON.stringify(this.actualDir.tree));
      let indexEndRoute = materialTree.length - 1;
      if (indexEndRoute == -1) {
        materialTree.push({});
        indexEndRoute = 0;
      }
      materialTree[indexEndRoute]["idDir"] = this.actualDir._id;

      let dataUbication = {
        father: this.actualDir._id,
        tree: materialTree,
        orden: this.dataPaginationMtls.totalDocs + 1
      };
      this.$store.dispatch("constructor/setInfo", dataUbication);
      this.$router.push({ name: "Nuevo" });
    },
    changeDataDir(dir) {
      this.paramsDirs.filtro.father = dir._id;
      this.paramsMtls.filtro.father = dir._id;
      this.actualDir = dir;
      this.getRecordsDir(1);
    },
    returnParent(dir) {
      if (dir.father != undefined || dir.father != null) {
        DirectorioService.list(1, { filtro: { _id: dir.father } }).then(dir => {
          this.actualDir = dir[0];
          this.paramsDirs.filtro.father = dir[0]._id;
          this.paramsMtls.filtro.father = dir[0]._id;
          this.getRecordsDir(1);
        });
      }
    },
    returnDir(id) {
      DirectorioService.list(1, { filtro: { _id: id } }).then(dir => {
        this.actualDir = dir[0];
        this.paramsDirs.filtro.father = dir[0]._id;
        this.paramsMtls.filtro.father = dir[0]._id;
        this.getRecordsDir(1);
      });
    },
    targetFilter(e) {
      if (e.wordSearch) this.wordSearch = e.wordSearch;
      this.getRecordsDir(1);
    },
    /*resetFiltro() {
      this.paramsList.filtro = { type: null };
      this.wordSearch = "";
      this.getListRecursos(1);
    },*/
    resetFiltro() {
      this.paramsDirs.filtro['tags'] = null;
      this.paramsMtls.filtro['name'] = null;
      this.wordSearch = "";
      this.getRecordsDir(1);
    },
    getRecordsDir(page) {
      //this.directorios = new Array;
      this.recordsDir = new Array();
      var arrayPromises = new Array();
      var active = "";
      var orderPromises = ["dirs", "mtls"];
      if (this.wordSearch)
            this.paramsDirs.filtro["tags"] = {
              $regex: `.*${this.wordSearch}.*`,
              $options: "i"
            };
            this.paramsMtls.filtro["name"] = {
              $regex: `.*${this.wordSearch}.*`,
              $options: "i"
            };
      if (page <= this.dataPaginationDirs.totalPages)
        arrayPromises.push(DirectorioService.list(page, this.paramsDirs));
      else active = orderPromises[1];
      if (page <= this.dataPaginationMtls.totalPages)
        arrayPromises.push(MaterialService.list(page, this.paramsMtls));
      else active = orderPromises[0];
      Promise.all(arrayPromises)
        .then(responses => {
          if (responses.length > 1) {
            responses.forEach((groupRecs, i, a) => {
              if (!i) {
                this.dataPaginationDirs = JSON.parse(JSON.stringify(groupRecs));
                delete this.dataPaginationDirs.docs;
                //this.directorios = groupRecs.docs;
              } else {
                this.dataPaginationMtls = JSON.parse(JSON.stringify(groupRecs));
                delete this.dataPaginationMtls.docs;
                this.materiales = groupRecs.docs;
              }
              if (groupRecs.docs.length) {
                groupRecs.docs.forEach(rec => {
                  rec["typeRec"] = orderPromises[i];
                  this.recordsDir.push(rec);
                });
              }

              if (i == a.length - 1) {
                if (
                  this.dataPaginationDirs.totalPages >
                  this.dataPaginationMtls.totalPages
                )
                  this.dataPagination = this.dataPaginationDirs;
                else this.dataPagination = this.dataPaginationMtls;
              }
            });
          } else {
            // cuando uno de los grupos ya no tiene hojas para consultar / ya no tiene que mostrar

            if (active == "dirs") {
              this.dataPaginationDirs = JSON.parse(
                JSON.stringify(responses[0])
              );
              delete this.dataPaginationDirs.docs;
              this.dataPagination = this.dataPaginationDirs;
              //this.directorios = responses[0];
            } else {
              this.dataPaginationMtls = JSON.parse(
                JSON.stringify(responses[0])
              );
              delete this.dataPaginationMtls.docs;
              this.dataPagination = this.dataPaginationMtls;
            }

            if (responses[0].docs.length) {
              responses[0].docs.forEach(rec => {
                rec["typeRec"] = active;
                this.recordsDir.push(rec);
              });
            }
          }
        })
        .catch(err => console.log(err));
    },
    onNewDir() {
      this.$swal
        .fire({
          title: "Nueva Carpeta",
          text: "Agregar un Nombre a la Carpeta",
          input: "text",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Crear",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
        })
        .then(result => {
          if (result.value) {
            let treeForNew = JSON.parse(JSON.stringify(this.actualDir.tree));
            let indexEndRoute = treeForNew.length - 1;
            if (indexEndRoute == -1) {
              treeForNew.push({});
              indexEndRoute = 0;
            }
            treeForNew[indexEndRoute]["idDir"] = this.actualDir._id;
            treeForNew.push({ name: result.value });

            let data = {
              name: result.value,
              father: this.actualDir._id,
              author: this.user._id,
              orden: this.dataPaginationDirs.totalDocs + 1,
              tree: treeForNew,
              tags: [result.value]
            };
            DirectorioService.save(data).then(response => {
              this.getRecordsDir(this.dataPagination.page);
            });
          }
        });
    },
    onClickButton(data) {
      console.log(data.record.data);
      if (data && data.id) {
        switch (data.id) {
          case "btn-show":
            this.$store.dispatch("constructor/activePreview");
            this.$router.push({
              name: "MostrarMaterial",
              params: { type: this.materia, id: data.record.data._id }
            });
            break;
          case "btn-edit":
        }
      }
    }
  },
  created() {
    this.user = this.$store.getters["auth/infoUser"];
    this.materia = this.$route.params.materia;
    var objCursoPromise = this.$store.dispatch(
      "directorio/getInfoCurso",
      this.materia
    );

    let body = document.getElementsByTagName("body");
    body[0].classList.add("sidebar-lg-show");

    objCursoPromise
      .then(obj => {
        console.log("Object returned: ", obj);

        if (obj._id) {
          this.materiaObj = obj;
          this.actualDir = this.materiaObj;
          this.paramsDirs.filtro.author = this.user._id;
          this.paramsDirs.filtro.father = this.materiaObj._id;
          this.paramsMtls.filtro.author = this.user._id;
          this.paramsMtls.filtro.father = this.materiaObj._id;
          this.getRecordsDir(1);
          return 0;
        } else {
          var filter = /^[0-9a-fA-F]{1,}$/i.test(this.materia)
            ? { filtro: { _id: this.materia } }
            : { filtro: { name: this.materia } };
          return DirectorioService.list(1, filter);
        }
      })
      .then(response => {
        console.log("Response: ", response);

        if (response) {
          this.materiaObj = response[0];
          this.actualDir = this.materiaObj;
          this.paramsDirs.filtro.author = this.user._id;
          this.paramsDirs.filtro.father = this.materiaObj._id;
          this.paramsMtls.filtro.author = this.user._id;
          this.paramsMtls.filtro.father = this.materiaObj._id;
          this.getRecordsDir(1);
        }
      });
  }
};
</script>
